import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, EffectCoverflow } from 'swiper';
import CommunitySliderCard from './CommunitySliderCard';
import { unitConversion } from '../../helpers';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import FeaturedCommunitySliderCard from './FeaturedCommunitySliderCard';
SwiperCore.use([Navigation, Pagination, EffectCoverflow]);

export const CommunitiesSlider = ({
  displayedResults = [],
  coveoUnit = 'mi',
  showPagination = false,
  featuredItems = null,
  isNearby = false,
  featuredItemsCta = 'Learn More'
}) => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    swiperInstance && swiperInstance.update();
    setCurrentIndex(1);
  }, [displayedResults]);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
      swiperInstance && swiperInstance.update();
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getPrevButtonLabel = () => {
    if (displayedResults && displayedResults.length > 1) {
      const index =
        currentIndex - 2 < 0 ? displayedResults.length - 1 : currentIndex - 2;
      return (
        !isMobile && (
          <div>
            {' '}
            <span className="communities-slider__arrow-label">
              {displayedResults[index].raw.ssl_communityname}
            </span>
            <div>
              {unitConversion(displayedResults[index].raw.distance, coveoUnit)}
              {coveoUnit.toUpperCase()}
            </div>
          </div>
        )
      );
    } else if (featuredItems && featuredItems.length > 1) {
      const index =
        currentIndex - 2 < 0 ? featuredItems.length - 1 : currentIndex - 2;
      return (
        !isMobile && (
          <div>
            {' '}
            <span className="communities-slider__arrow-label">
              {featuredItems[index].heading}
            </span>
          </div>
        )
      );
    }
    return <></>;
  };

  const getNextButtonLabel = () => {
    if (displayedResults && displayedResults.length > 1) {
      const index =
        currentIndex > displayedResults.length - 1 ? 0 : currentIndex;
      return (
        !isMobile && (
          <div>
            <span className="communities-slider__arrow-label">
              {displayedResults[index].raw.ssl_communityname}
            </span>
            <div>
              {unitConversion(displayedResults[index].raw.distance, coveoUnit)}
              {coveoUnit.toUpperCase()}
            </div>
          </div>
        )
      );
    } else if (featuredItems && featuredItems.length > 1) {
      const index = currentIndex > featuredItems.length - 1 ? 0 : currentIndex;
      return (
        !isMobile && (
          <div>
            <span className="communities-slider__arrow-label">
              {featuredItems[index].heading}
            </span>
          </div>
        )
      );
    }
    return <></>;
  };

  return (
    <>
      <div className="communities-slider">
        {displayedResults && displayedResults.length ? (
          <>
            <Swiper
              breakpoints={{
                1024: {
                  slidesPerView: 3,
                  effect: 'coverflow',
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    scale: 1,
                    depth: 200,
                    modifier: 0.75,
                    slideShadows: false
                  },
                  pagination: false
                }
              }}
              pagination={{
                el: '.communities-slider__bullet-pagination',
                clickable: true
              }}
              grabCursor={true}
              centeredSlides={displayedResults.length < 3 ? false : true}
              loop={displayedResults.length < 3 ? false : true}
              className={
                displayedResults.length < 3 ? 'swiper-wrapper--no-swipe' : ''
              }
              slidesPerView={1}
              onInit={swiper => {
                swiper.slideToLoop(displayedResults.length, 0);
              }}
              onSlideChange={swiper => {
                setCurrentIndex(swiper.realIndex + 1);
              }}
              onSwiper={setSwiperInstance}
              slideToClickedSlide={true}
              modules={[EffectCoverflow, Pagination, Navigation]}
              navigation={{
                nextEl: '.communities-slider__arrow--next',
                prevEl: '.communities-slider__arrow--prev'
              }}
            >
              {displayedResults.map((result, index) => (
                <SwiperSlide
                  className="coveo-list-layout"
                  key={index + result.raw.ssl_communityid}
                >
                  <CommunitySliderCard
                    result={result}
                    distanceUnit={coveoUnit}
                    isNearby={isNearby}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            {(displayedResults.length > 2 || featuredItems.length > 2) && (
              <div className="communities-slider__navigation">
                <button
                  aria-label="Previous"
                  className="communities-slider__navigation--prev"
                  onClick={() => swiperInstance.slidePrev()}
                >
                  <span className="communities-slider__arrow">
                    <svg
                      viewBox="0 0 72 72"
                      width="40"
                      height="40"
                      role="presentation"
                    >
                      <use xlinkHref="#arrow-left-circle"></use>
                    </svg>
                    <svg
                      viewBox="0 0 72 72"
                      className="slider-pagination-row-prev-hover"
                      width="40"
                      height="40"
                      role="presentation"
                    >
                      <use xlinkHref="#arrow-left-no-circle"></use>
                    </svg>
                  </span>
                  <div className="communities-slider__navigation--label">
                    {getPrevButtonLabel()}
                  </div>
                </button>
                <div className="communities-slider__bullet-pagination"></div>
                <button
                  aria-label="Next"
                  className="communities-slider__navigation--next"
                  onClick={() => swiperInstance.slideNext()}
                >
                  <div className="communities-slider__navigation--label">
                    {getNextButtonLabel()}
                  </div>
                  <span className="communities-slider__arrow">
                    <svg
                      viewBox="0 0 72 72"
                      width="40"
                      height="40"
                      role="presentation"
                    >
                      <use xlinkHref="#arrow-right-circle"></use>
                    </svg>
                    <svg
                      viewBox="0 0 72 72"
                      className="slider-pagination-row-next-hover"
                      width="40"
                      height="40"
                      role="presentation"
                    >
                      <use xlinkHref="#arrow-right-no-circle"></use>
                    </svg>
                  </span>
                </button>
              </div>
            )}
            {showPagination && (
              <div className="communities-slider__pagination">
                {currentIndex} of {displayedResults.length}
              </div>
            )}
          </>
        ) : (
          <>
            {featuredItems && featuredItems.length > 0 && (
              <>
                <Swiper
                  breakpoints={{
                    1024: {
                      slidesPerView:
                        featuredItems.length > 2 ? 3 : featuredItems.length,
                      effect: 'coverflow',
                      coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        scale: 1,
                        depth: 200,
                        modifier: 0.75,
                        slideShadows: false
                      },
                      pagination: false
                    }
                  }}
                  pagination={{
                    el: '.communities-slider__bullet-pagination',
                    clickable: true
                  }}
                  grabCursor={true}
                  centeredSlides={featuredItems.length < 3 ? false : true}
                  loop={featuredItems.length < 3 ? false : true}
                  className={
                    featuredItems.length < 3 ? 'swiper-wrapper--no-swipe' : ''
                  }
                  slidesPerView={1}
                  onInit={swiper => {
                    swiper.slideToLoop(featuredItems.length, 0);
                  }}
                  onSlideChange={swiper => {
                    setCurrentIndex(swiper.realIndex + 1);
                  }}
                  onSwiper={setSwiperInstance}
                  slideToClickedSlide={true}
                  modules={[EffectCoverflow, Pagination, Navigation]}
                  navigation={{
                    nextEl: '.communities-slider__arrow--next',
                    prevEl: '.communities-slider__arrow--prev'
                  }}
                >
                  {featuredItems.map((item, index) => (
                    <SwiperSlide
                      className="coveo-list-layout"
                      key={index + item.Heading}
                    >
                      <FeaturedCommunitySliderCard
                        item={item}
                        distanceUnit={coveoUnit}
                        isNearby={isNearby}
                        featuredItemsCta={featuredItemsCta}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                {featuredItems.length > 2 && (
                  <div className="communities-slider__navigation">
                    <button
                      aria-label="Previous"
                      className="communities-slider__navigation--prev"
                      onClick={() => swiperInstance.slidePrev()}
                    >
                      <span className="communities-slider__arrow">
                        <svg
                          viewBox="0 0 72 72"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-left-circle"></use>
                        </svg>
                        <svg
                          viewBox="0 0 72 72"
                          className="slider-pagination-row-prev-hover"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-left-no-circle"></use>
                        </svg>
                      </span>
                      <div>{getPrevButtonLabel()}</div>
                    </button>
                    <button
                      aria-label="Next"
                      className="communities-slider__navigation--next"
                      onClick={() => swiperInstance.slideNext()}
                    >
                      <div>{getNextButtonLabel()}</div>
                      <span className="communities-slider__arrow">
                        <svg
                          viewBox="0 0 72 72"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-right-circle"></use>
                        </svg>
                        <svg
                          viewBox="0 0 72 72"
                          className="slider-pagination-row-next-hover"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-right-no-circle"></use>
                        </svg>
                      </span>
                    </button>
                  </div>
                )}
                {isMobile && (
                  <div className="communities-slider__navigation">
                    <button
                      aria-label="Previous"
                      className="communities-slider__navigation--prev"
                      onClick={() => swiperInstance.slidePrev()}
                    >
                      <span className="communities-slider__arrow">
                        <svg
                          viewBox="0 0 72 72"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-left-circle"></use>
                        </svg>
                        <svg
                          viewBox="0 0 72 72"
                          className="slider-pagination-row-prev-hover"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-left-no-circle"></use>
                        </svg>
                      </span>
                      <div>{getPrevButtonLabel()}</div>
                    </button>
                    <button
                      aria-label="Next"
                      className="communities-slider__navigation--next"
                      onClick={() => swiperInstance.slideNext()}
                    >
                      <div>{getNextButtonLabel()}</div>
                      <span className="communities-slider__arrow">
                        <svg
                          viewBox="0 0 72 72"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-right-circle"></use>
                        </svg>
                        <svg
                          viewBox="0 0 72 72"
                          className="slider-pagination-row-next-hover"
                          width="40"
                          height="40"
                          role="presentation"
                        >
                          <use xlinkHref="#arrow-right-no-circle"></use>
                        </svg>
                      </span>
                    </button>
                  </div>
                )}
                {showPagination && (
                  <div className="communities-slider__pagination">
                    {currentIndex} of {displayedResults.length}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
